<template>
  <div class="container">
    <ul class="list">
      <ComplaintItem
        :complainInfo="drugComplainInfo"
        @currentChange="
          page => loadTableData(page, drugComplainInfo.source, '药品')
        "
        @sourceChange="loadTableData(1, drugComplainInfo.source, '药品')"
      />
      <ComplaintItem
        bgName="bg-squre"
        :complainInfo="apparatusComplainInfo"
        @currentChange="
          page => loadTableData(page, apparatusComplainInfo.source, '医疗器械')
        "
        @sourceChange="
          loadTableData(1, apparatusComplainInfo.source, '医疗器械')
        "
      />
      <ComplaintItem
        bgName="bg-rectangle"
        :complainInfo="cosmeticsComplainInfo"
        @currentChange="
          page => loadTableData(page, cosmeticsComplainInfo.source, '化妆品')
        "
        @sourceChange="loadTableData(1, cosmeticsComplainInfo.source, '化妆品')"
      />
    </ul>
  </div>
</template>

<script>
import ComplaintItem from './complaint-item';
const mapTypeToKey = {
  药品: 'drugComplainInfo',
  医疗器械: 'apparatusComplainInfo',
  化妆品: 'cosmeticsComplainInfo'
};

export default {
  data() {
    return {
      drugComplainInfo: {
        source: '',
        echartsOption: {
          gird: {
            containLabel: true
          },
          legend: {
            orient: 'vertical',
            right: '10%',
            top: '30%',
            itemGap: 21,
            data: ['电话', '网络', '信件', '走访'],
            itemWidth: 12,
            itemHeight: 12,
            icon: 'circle'
          },
          backgroundColor: '#ffffff',
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          color: ['#386CE2', '#5140C6', '#FFB439', '#2BBF99'],
          series: [
            {
              name: '投诉来源',
              type: 'pie',
              label: {
                show: false
              },
              animation: false,
              center: ['35%', '50%'],
              radius: ['55%', '65%'],
              data: [
                {
                  value: 335,
                  name: '电话'
                },
                { value: 310, name: '网络' },
                { value: 234, name: '信件' },
                { value: 135, name: '走访' }
              ],
              itemStyle: {
                normal: {
                  borderColor: '#ffffff',
                  borderWidth: 5
                }
              }
            },
            {
              name: '投诉来源',
              type: 'pie',
              center: ['35%', '50%'],
              radius: ['35%', '60%'],
              data: [
                { value: 335, name: '电话' },
                { value: 310, name: '网络' },
                { value: 234, name: '信件' },
                { value: 135, name: '走访' }
              ],
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    formatter: '{b}\n{c} ({d}%)'
                  },
                  borderColor: '#ffffff',
                  borderWidth: 5
                },
                labelLine: { show: true }
              },
              labelLine: {
                show: true,
                normal: {
                  length: 30,
                  length2: 20
                }
              }
            },
            {
              name: '投诉来源',
              type: 'pie',
              center: ['35%', '50%'],
              radius: ['30%'],
              data: [{ value: 100 }],
              tooltip: {
                show: false
              },
              itemStyle: {
                normal: {
                  color: '#CEDBEF'
                }
              },
              label: {
                normal: {
                  formatter: '投诉来源',
                  position: 'center',
                  textStyle: {
                    fontSize: 16,
                    color: '#386CE2'
                  }
                }
              }
            }
          ]
        },
        tableList: [],
        pageInfo: {
          currentPage: 1,
          total: 0
        },
        type: '药品'
      },
      apparatusComplainInfo: {
        source: '',
        echartsOption: {
          legend: {
            orient: 'vertical',
            right: '10%',
            top: '30%',
            itemGap: 21,
            data: ['电话', '网络', '信件', '走访'],
            itemWidth: 12,
            itemHeight: 12,
            icon: 'circle'
          },
          backgroundColor: '#ffffff',
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          color: ['#386CE2', '#5140C6', '#FFB439', '#2BBF99'],
          series: [
            {
              name: '投诉来源',
              type: 'pie',
              label: {
                show: false
              },
              animation: false,
              center: ['35%', '50%'],
              radius: ['55%', '65%'],
              data: [
                {
                  value: 335,
                  name: '电话'
                },
                { value: 310, name: '网络' },
                { value: 234, name: '信件' },
                { value: 135, name: '走访' }
              ],
              itemStyle: {
                normal: {
                  borderColor: '#ffffff',
                  borderWidth: 5
                }
              },
              labelLine: {
                show: true,
                normal: {
                  length: 30,
                  length2: 20
                }
              }
            },
            {
              name: '投诉来源',
              type: 'pie',
              center: ['35%', '50%'],
              radius: ['35%', '60%'],
              data: [
                { value: 335, name: '电话' },
                { value: 310, name: '网络' },
                { value: 234, name: '信件' },
                { value: 135, name: '走访' }
              ],
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    formatter: '{b}\n{c} ({d}%)'
                  },
                  borderColor: '#ffffff',
                  borderWidth: 5
                },
                labelLine: { show: true }
              }
            },
            {
              name: '投诉来源',
              type: 'pie',
              center: ['35%', '50%'],
              radius: ['30%'],
              data: [{ value: 100 }],
              itemStyle: {
                normal: {
                  color: '#CEDBEF'
                }
              },
              tooltip: {
                show: false
              },
              label: {
                normal: {
                  formatter: '投诉来源',
                  position: 'center',
                  textStyle: {
                    fontSize: 16,
                    color: '#386CE2'
                  }
                }
              }
            }
          ]
        },
        tableList: [],
        pageInfo: {
          currentPage: 1,
          total: 0
        },
        type: '医疗器械'
      },
      cosmeticsComplainInfo: {
        source: '',
        echartsOption: {
          legend: {
            orient: 'vertical',
            right: '10%',
            top: '30%',
            itemGap: 21,
            data: ['电话', '网络', '信件', '走访'],
            itemWidth: 12,
            itemHeight: 12,
            icon: 'circle'
          },
          backgroundColor: '#ffffff',
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          color: ['#386CE2', '#5140C6', '#FFB439', '#2BBF99'],
          series: [
            {
              name: '投诉来源',
              type: 'pie',
              label: {
                show: false
              },
              animation: false,
              center: ['35%', '50%'],
              radius: ['55%', '65%'],
              data: [
                { value: 335, name: '电话' },
                { value: 310, name: '网络' },
                { value: 234, name: '信件' },
                { value: 135, name: '走访' }
              ],
              itemStyle: {
                normal: {
                  borderColor: '#ffffff',
                  borderWidth: 5
                }
              }
            },
            {
              name: '投诉来源',
              type: 'pie',
              center: ['35%', '50%'],
              radius: ['35%', '60%'],
              data: [
                { value: 335, name: '电话' },
                { value: 310, name: '网络' },
                { value: 234, name: '信件' },
                { value: 135, name: '走访' }
              ],
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    formatter: '{b}\n{c} ({d}%)'
                  },
                  borderColor: '#ffffff',
                  borderWidth: 5
                }
              },
              labelLine: {
                show: true,
                normal: {
                  length: 30,
                  length2: 20
                }
              }
            },
            {
              name: '投诉来源',
              type: 'pie',
              center: ['35%', '50%'],
              radius: ['30%'],
              data: [{ value: 100 }],
              itemStyle: {
                normal: {
                  color: '#CEDBEF'
                }
              },
              tooltip: {
                show: false
              },
              label: {
                normal: {
                  formatter: '投诉来源',
                  position: 'center',
                  textStyle: {
                    fontSize: 16,
                    color: '#386CE2'
                  }
                }
              }
            }
          ]
        },
        tableList: [],
        pageInfo: {
          currentPage: 1,
          total: 0
        },
        type: '化妆品'
      }
    };
  },
  mounted() {
    this.loadDrugComplainInfo();
    this.loadApparatusComplainInfo();
    this.loadCosmeticsComplainInfo();
  },
  methods: {
    // 加载图表数据
    loadEchartsData(source, type) {
      this.$request({
        url: 'rest/statistic/reportData',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: '1',
              pageSize: '1000'
            },
            params: {
              handlerName: 'complain_source_statics',
              source,
              type
            }
          })
        }
      }).then(res => {
        const numberData = res.list[0];
        const seriesData = [
          { name: '电话', value: numberData.phone_num },
          { name: '网络', value: numberData.wl_num },
          { name: '信件', value: numberData.xj_num },
          { name: '走访', value: numberData.zf_num }
        ].filter(item => item.value);
        if (seriesData.length === 1) {
          this[
            mapTypeToKey[type]
          ].echartsOption.series[0].itemStyle.normal.borderWidth = 0;
          this[
            mapTypeToKey[type]
          ].echartsOption.series[1].itemStyle.normal.borderWidth = 0;
        }
        this[mapTypeToKey[type]].echartsOption.series[0].data = seriesData;
        this[mapTypeToKey[type]].echartsOption.series[1].data = seriesData;
        if (
          !numberData.phone_num &&
          !numberData.wl_num &&
          !numberData.xj_num &&
          !numberData.zf_num
        ) {
          this[
            mapTypeToKey[type]
          ].echartsOption.series[2].label.normal.formatter = '暂无数据';
        }
      });
    },
    // 加载table数据
    loadTableData(pageNum, source, type) {
      if (source === '电话') {
        this[mapTypeToKey[type]].echartsOption.color = [
          'rgba(56,108,226,1)',
          'rgba(81,64,198,0.3)',
          'rgba(255,180,57,0.3)',
          'rgba(43,191,153,0.3)'
        ];
      } else if (source === '网络') {
        this[mapTypeToKey[type]].echartsOption.color = [
          'rgba(56,108,226,0.3)',
          'rgba(81,64,198,1)',
          'rgba(255,180,57,0.3)',
          'rgba(43,191,153,0.3)'
        ];
      } else if (source === '信件') {
        this[mapTypeToKey[type]].echartsOption.color = [
          'rgba(56,108,226,0.3)',
          'rgba(81,64,198,0.3)',
          'rgba(255,180,57,1)',
          'rgba(43,191,153,0.3)'
        ];
      } else if (source === '走访') {
        this[mapTypeToKey[type]].echartsOption.color = [
          'rgba(56,108,226,0.3)',
          'rgba(81,64,198,0.3)',
          'rgba(255,180,57,0.3)',
          'rgba(43,191,153,1)'
        ];
      } else {
        this[mapTypeToKey[type]].echartsOption.color = [
          'rgba(56,108,226,1)',
          'rgba(81,64,198,1)',
          'rgba(255,180,57,1)',
          'rgba(43,191,153,1)'
        ];
      }

      this.$request({
        url: 'rest/statistic/reportData',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum,
              pageSize: '6'
            },
            params: {
              handlerName: 'complain_list',
              source,
              type
            }
          })
        }
      }).then(res => {
        const list = res.list || [];
        this[mapTypeToKey[type]].tableList = [...list];
        this[mapTypeToKey[type]].pageInfo.total = res.total;
      });
    },
    // 加载药品投诉数据
    loadDrugComplainInfo() {
      const source = this.drugComplainInfo.source;
      this.loadEchartsData(source, '药品');
      this.loadTableData(1, source, '药品');
    },
    // 加载医疗器械投诉数据
    loadApparatusComplainInfo() {
      const source = this.apparatusComplainInfo.source;
      this.loadEchartsData(source, '医疗器械');
      this.loadTableData(1, source, '医疗器械');
    },
    // 加载化妆品投诉数据
    loadCosmeticsComplainInfo() {
      const source = this.apparatusComplainInfo.source;
      this.loadEchartsData(source, '化妆品');
      this.loadTableData(1, source, '化妆品');
    }
  },
  components: {
    ComplaintItem
  }
};
</script>

<style lang="stylus" scoped></style>
